import { render, staticRenderFns } from "./select-coupon.vue?vue&type=template&id=58a8fa71&scoped=true&"
import script from "./select-coupon.vue?vue&type=script&lang=js&"
export * from "./select-coupon.vue?vue&type=script&lang=js&"
import style0 from "./select-coupon.vue?vue&type=style&index=0&id=58a8fa71&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a8fa71",
  null
  
)

export default component.exports